export default "__VITE_ASSET__Nd0ikdTI__"